module.exports = __webpack_public_path__ + "img/Banner-Traffic-Campaign.8fac59b.png";